/* ═══════════════════════════════════════════
   RDI Header — Stripe-style Morphing Mega Menu
   ═══════════════════════════════════════════ */

(function () {
  'use strict';

  var header = document.querySelector('[data-header]');
  if (!header) return;

  /* ─── Elements ─── */
  var mega = header.querySelector('[data-mega]');
  var megaBg = header.querySelector('[data-mega-bg]');
  var triggers = header.querySelectorAll('[data-nav-trigger]');
  var panels = header.querySelectorAll('[data-panel]');
  var currentPanel = null;
  var closeTimer = null;
  var resetTimer = null;
  var isOpen = false;
  var panelCache = {};

  /* ─── Measure panel dimensions (cached) ─── */
  function measurePanel(panel) {
    var id = panel.getAttribute('data-panel');
    if (panelCache[id]) return panelCache[id];

    panel.style.cssText = 'opacity:0;pointer-events:none;display:block;position:absolute;visibility:hidden;left:0;top:0;width:auto;white-space:normal';
    var w = panel.scrollWidth;
    var h = panel.scrollHeight;
    panel.style.cssText = '';

    panelCache[id] = { width: w, height: h };
    return panelCache[id];
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { panelCache = {}; }, 200);
  }, { passive: true });

  /* ─── Deactivate all triggers and panels ─── */
  function deactivateAll() {
    triggers.forEach(function (t) { t.classList.remove('is-active'); });
    panels.forEach(function (p) { p.classList.remove('is-active'); });
  }

  /* ─── Open / switch to a panel ─── */
  function openPanel(panelId, triggerEl) {
    clearTimeout(closeTimer);
    clearTimeout(resetTimer);

    /* If we're re-opening during a close fade, restore transitions immediately */
    megaBg.style.transition = '';

    var panel = mega.querySelector('[data-panel="' + panelId + '"]');
    if (!panel) return;

    /* Deactivate, then activate the target */
    deactivateAll();
    triggerEl.classList.add('is-active');
    panel.classList.add('is-active');
    currentPanel = panelId;

    /* Measure */
    var size = measurePanel(panel);
    var headerRect = header.getBoundingClientRect();
    var triggerRect = triggerEl.getBoundingClientRect();

    var maxW = Math.min(size.width, headerRect.width - 48);
    var panelW = Math.max(maxW, 400);
    var panelH = size.height;

    var triggerCenter = triggerRect.left + triggerRect.width / 2 - headerRect.left;
    var panelLeft = triggerCenter - panelW / 2;
    var rightEdge = headerRect.width - 24;
    if (panelLeft + panelW > rightEdge) panelLeft = rightEdge - panelW;
    if (panelLeft < 24) panelLeft = 24;

    panel.style.left = panelLeft + 'px';
    panel.style.width = panelW + 'px';

    var wasOpen = isOpen;

    if (!wasOpen) {
      /* First open or re-open after close started — snap bg to position, then fade in */
      megaBg.style.transition = 'none';
      megaBg.style.left = panelLeft + 'px';
      megaBg.style.width = panelW + 'px';
      megaBg.style.height = panelH + 'px';
      megaBg.offsetHeight;
      megaBg.style.transition = '';
      mega.classList.add('is-open');
      mega.style.pointerEvents = 'auto';
      isOpen = true;
    } else {
      /* Already open — morph to new position/size */
      megaBg.style.left = panelLeft + 'px';
      megaBg.style.width = panelW + 'px';
      megaBg.style.height = panelH + 'px';
    }
  }

  /* ─── Close: hide panels + bg together, then reset ─── */
  function closeMenu() {
    clearTimeout(closeTimer);
    clearTimeout(resetTimer);

    /* Immediately hide everything visually */
    mega.classList.remove('is-open');
    mega.style.pointerEvents = '';
    deactivateAll();
    currentPanel = null;
    isOpen = false;

    /* After bg fade-out completes, reset dimensions */
    resetTimer = setTimeout(function () {
      megaBg.style.transition = 'none';
      megaBg.style.width = '0';
      megaBg.style.height = '0';
      megaBg.offsetHeight;
      megaBg.style.transition = '';
    }, 300);
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(closeMenu, 200);
  }

  /* Close on scroll */
  window.addEventListener('scroll', function () {
    if (isOpen) {
      clearTimeout(closeTimer);
      closeMenu();
    }
  }, { passive: true });

  /* ─── Desktop triggers ─── */
  triggers.forEach(function (trigger) {
    var panelId = trigger.getAttribute('data-nav-trigger');

    trigger.addEventListener('mouseenter', function () {
      openPanel(panelId, trigger);
    });

    trigger.addEventListener('mouseleave', function () {
      scheduleClose();
    });

    trigger.addEventListener('click', function (e) {
      if (trigger.hasAttribute('href') && trigger.getAttribute('href') !== '#') {
        return;
      }
      e.preventDefault();
      if (currentPanel === panelId && isOpen) {
        closeMenu();
      } else {
        openPanel(panelId, trigger);
      }
    });
  });

  /* Keep open while hovering mega area */
  mega.addEventListener('mouseenter', function () {
    clearTimeout(closeTimer);
  });

  mega.addEventListener('mouseleave', function () {
    scheduleClose();
  });

  /* Close when mouse leaves header entirely */
  header.addEventListener('mouseleave', function () {
    if (isOpen) scheduleClose();
  });

  /* Close on click outside */
  document.addEventListener('click', function (e) {
    if (isOpen && !header.contains(e.target)) closeMenu();
  });

  /* Close on Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) closeMenu();
  });


  /* ═══════════════════════════════════════════
     MOBILE NAVIGATION
     ═══════════════════════════════════════════ */

  var mobileToggle = header.querySelector('[data-mobile-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var mobileClose = document.querySelector('[data-mobile-close]');
  var overlay = document.querySelector('[data-overlay]');

  function openMobile() {
    mobileNav.classList.add('is-open');
    overlay.classList.add('is-visible');
    document.body.classList.add('mobile-nav-open');
    document.body.style.overflow = 'hidden';
    mobileToggle.setAttribute('aria-expanded', 'true');
  }

  function closeMobile() {
    mobileNav.classList.remove('is-open');
    overlay.classList.remove('is-visible');
    document.body.classList.remove('mobile-nav-open');
    document.body.style.overflow = '';
    mobileToggle.setAttribute('aria-expanded', 'false');
  }

  if (mobileToggle) {
    mobileToggle.addEventListener('click', function () {
      mobileNav.classList.contains('is-open') ? closeMobile() : openMobile();
    });
  }

  if (mobileClose) mobileClose.addEventListener('click', closeMobile);
  if (overlay) overlay.addEventListener('click', closeMobile);

  /* Top-level accordions */
  var accordionTriggers = document.querySelectorAll('[data-accordion-trigger]');
  accordionTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var group = trigger.closest('[data-accordion]');
      var wasOpen = group.classList.contains('is-open');
      var content = group.querySelector('[data-accordion-content]');

      /* Close all top-level */
      document.querySelectorAll('[data-accordion]').forEach(function (g) {
        g.classList.remove('is-open');
        g.querySelector('[data-accordion-trigger]').setAttribute('aria-expanded', 'false');
        var c = g.querySelector('[data-accordion-content]');
        if (c) c.style.maxHeight = '';
        g.querySelectorAll('[data-sub-accordion]').forEach(function (s) {
          s.classList.remove('is-open');
          var st = s.querySelector('[data-sub-accordion-trigger]');
          if (st) st.setAttribute('aria-expanded', 'false');
        });
      });

      /* Toggle with measured height */
      if (!wasOpen) {
        group.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        if (content) content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });

  /* Nested sub-accordions */
  document.querySelectorAll('[data-sub-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var sub = trigger.closest('[data-sub-accordion]');
      var wasOpen = sub.classList.contains('is-open');
      var parent = sub.parentElement;
      var accordion = sub.closest('[data-accordion]');
      var accordionContent = accordion ? accordion.querySelector('[data-accordion-content]') : null;

      /* Close siblings */
      parent.querySelectorAll('[data-sub-accordion]').forEach(function (s) {
        s.classList.remove('is-open');
        var st = s.querySelector('[data-sub-accordion-trigger]');
        if (st) st.setAttribute('aria-expanded', 'false');
      });

      /* Toggle */
      if (!wasOpen) {
        sub.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }

      /* Recalculate parent accordion height */
      if (accordionContent) {
        requestAnimationFrame(function () {
          accordionContent.style.maxHeight = accordionContent.scrollHeight + 'px';
        });
      }
    });
  });

})();
